import React, { FC } from 'react'

import clsx from 'clsx'

import { Icon, LoadingIcon } from 'src/components/atoms'

type Props = {
  isEditMode: boolean
  updateIsEditMode: (newValue: boolean) => void
  finishEdit: () => void
  isLoading?: boolean
  enabledCheckButton?: boolean
  disabled?: boolean
  onClickSetting?: () => void
  onClickCancel?: () => void
  className?: string
}

export const SettingButtons: FC<Props> = ({
  finishEdit,
  isEditMode,
  updateIsEditMode,
  isLoading = false,
  enabledCheckButton = true,
  disabled = false,
  onClickSetting,
  onClickCancel,
  className,
}) => {
  const handleOnClickSetting = () => {
    updateIsEditMode(true)
    onClickSetting?.()
  }

  const handleOnClickCancel = () => {
    updateIsEditMode(false)
    onClickCancel?.()
  }

  return (
    <div className={className}>
      <div className="tw-full-justify">
        {isLoading ? (
          <LoadingIcon />
        ) : !disabled && isEditMode ? (
          <div className="tw-text-standardText-secondary hover:tw-text-standardText-primary tw-flex tw-gap-s0">
            <button type="button" className="tw-cursor-pointer" onClick={handleOnClickCancel}>
              <Icon path="close/soft/line" size="--r2" />
            </button>
            <button
              type="button"
              className={
                enabledCheckButton
                  ? 'tw-cursor-pointer'
                  : 'tw-text-standardText-disable tw-cursor-default'
              }
              onClick={() => enabledCheckButton && finishEdit()}
            >
              <Icon path="check/soft/line" size="--r2" />
            </button>
          </div>
        ) : (
          <button
            type="button"
            className={clsx(!disabled && 'tw-cursor-pointer')}
            onClick={handleOnClickSetting}
            disabled={disabled}
          >
            <Icon
              path="settings/soft/line"
              size="--r2"
              className={clsx(
                disabled ? 'tw-text-standardText-disable' : 'tw-text-standardText-secondary',
                !disabled && 'hover:tw-text-standardText-primary'
              )}
            />
          </button>
        )}
      </div>
    </div>
  )
}
